import React from 'react';
import {
  Select,
  FormItem
} from 'elmo-elements';
import { Data, DropDownProps } from '../type';
import { getSelectedValue } from '../helpers';

export type DataProps = {
  handleOnChangeSelect: (e: DropDownProps, name: string) => void;
  handleOnChangeStatus?: (e: DropDownProps) => void;
  data: Data;
};
const options = [
  {
    label: 'All statuses',
    value: 'all',
  },
  {
    label: 'Approved',
    value: 'approved',
  },
  {
    label: 'Pending',
    value: 'pending',
  },
  {
    label: 'In progress',
    value: 'in_progress',
  },
];
const TimesheetStatusFilter = ({
  data,
  handleOnChangeStatus,
}: DataProps) =>
{
  return (
     <FormItem label={'Timesheet Status'} isFluid={false} isInline={true}>
        <Select
          name={'status'}
          options={options}
          onChange={handleOnChangeStatus}
          defaultValue={[]}
          value={getSelectedValue(options, data.status)}
          ariaLabel="Status"
        />
     </FormItem>
  );
};

export default TimesheetStatusFilter;
